import { Styles } from "types";

export const styles: Styles = {
    banner: {
        h: 267,
        w: 352,
        borderRadius: 8,
    },
};
